<script setup>
import { useDialogPluginComponent } from "quasar";
import { fetchWithHeaders } from "@/utils";
import { ref } from "vue";
import { useRoute } from "vue-router";

// Définir les props EN PREMIER avant de les utiliser
const props = defineProps({
    registration: {
        type: Object,
        required: true,
    },
});

defineEmits([
    // REQUIRED; need to specify some events that your
    // component will emit through useDialogPluginComponent()
    ...useDialogPluginComponent.emits,
]);

const registration = ref(null);
const route = useRoute();

if (props.registration) {
    registration.value = JSON.parse(JSON.stringify(props.registration));
    if (!registration.value.user_data.epreuves) {
        registration.value.user_data.epreuves = [];
    }
}

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent();
// dialogRef      - Vue ref to be applied to QDialog
// onDialogHide   - Function to be used as handler for @hide on QDialog
// onDialogOK     - Function to call to settle dialog with "ok" outcome
//                    example: onDialogOK() - no payload
//                    example: onDialogOK({ /*...*/ }) - with payload
// onDialogCancel - Function to call to settle dialog with "cancel" outcome
const creating = ref(false);

async function onMatriculeRefresh() {
    const userData = await fetchWithHeaders(
        `${window._env_.API_ENDPOINT}/students/${registration.value.user_data.matricule}/?session=${route.params.sessionCode}`
    );
    registration.value.user_data = Object.assign({}, registration.value.user_data, userData);
}

async function onOKClick() {
    // generate all slots and send to api, ignore week-ends
    creating.value = true;
    if (registration.value.pk) {
        const url = `${window._env_.API_ENDPOINT}/registrations/${registration.value.pk}/`;
        await fetchWithHeaders(url, {
            method: "PUT",
            body: JSON.stringify(registration.value),
        });
    } else {
        const url = `${window._env_.API_ENDPOINT}/registrations/`;
        await fetchWithHeaders(url, {
            method: "POST",
            body: JSON.stringify(registration.value),
        });
    }
    creating.value = false;
    // on OK, it is REQUIRED to
    // call onDialogOK (with optional payload)
    // update with
    onDialogOK();
}
</script>

<template>
    <q-dialog ref="dialogRef" persistent no-esc-dismiss no-backdrop-dismiss @hide="onDialogHide">
        <q-card class="q-dialog-plugin">
            <q-card-section>
                <div class="text-h6">Gestion réservation</div>
            </q-card-section>
            <q-card-section>
                <q-input v-model="registration.user_data.surname" type="text" label="Nom de famille *"></q-input>
                <q-input v-model="registration.user_data.givenName" type="text" label="Prénom *"></q-input>
                <q-input v-model="registration.user_email" type="email" label="Adresse e-mail *"></q-input>
                <q-input v-model="registration.user_data.phone" type="text" label="Téléphone *"></q-input>
                <q-input v-model="registration.user_data.matricule" type="text" label="Matricule *">
                    <template #after>
                        <q-btn round dense flat icon="fa-solid fa-cloud-arrow-down" @click="onMatriculeRefresh">
                            <q-tooltip>Recharger les données de l'étudiant</q-tooltip>
                        </q-btn>
                    </template>
                </q-input>
                <q-input v-model="registration.user_data.plan" type="text" label="Formation" />
                <q-input v-model="registration.user_data.etape" type="text" label="Module d'étude" />
                <div class="q-mt-md">
                    <div class="text-caption">Epreuves</div>
                    <div v-for="(e, index) in registration.user_data.epreuves" :key="index">
                        <q-input v-model="registration.user_data.epreuves[index].eprnom" type="text" label="Nom">
                            <template #after>
                                <q-btn
                                    icon="fa-solid fa-trash"
                                    flat
                                    color="negative"
                                    @click="registration.user_data.epreuves.splice(index, 1)"
                                ></q-btn>
                            </template>
                        </q-input>
                    </div>
                    <q-btn
                        label="ajouter"
                        outline
                        color="primary"
                        class="q-mt-sm"
                        @click="registration.user_data.epreuves.push({ eprnom: '' })"
                    ></q-btn>
                </div>
                <q-input
                    v-model="registration.comment"
                    class="q-mt-md"
                    type="textarea"
                    label="Commentaire de l'étudiant"
                    filled
                ></q-input>
                <q-input
                    v-model="registration.admin_remark"
                    label-color="orange"
                    class="q-mt-xl"
                    type="textarea"
                    label="Remarque administrative"
                    filled
                ></q-input>
            </q-card-section>

            <q-card-actions v-if="!creating" align="right">
                <q-btn label="Annuler" @click="onDialogCancel" />
                <q-btn color="primary" :label="props.registration.pk ? 'Enregistrer' : 'Ajouter'" @click="onOKClick" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
